import { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SvgUsers from 'components/svg/SvgUsers';
import SpinnerBlock from 'components/others/SpinnerBlock';
import { useObjectCard } from '../context/ObjectCardProvider';
import OffExpendTeamInfo from '../OffExpendTeamInfo';
import ProposalShortageBlock from '../ProposalShortage';
import AddServiceModal from './AddServiceModal';
import ExpendTeamTableBody from './ExpendTeamTableBody/ExpendTeamTableBody';

const ObjectTabServices = () => {
    const { t } = useTranslation(['Objects']);
    const { vObject, isEditLocked } = useObjectCard();
    const [showAddServiceModal, setShowAddServiceModal] = useState(false);
    const [showSpinnerExpendTeam, setShowSpinnerExpendTeam] = useState(false);
    const [showExpendTeamInfo, setShowExpendInfo] = useState<number | false>(false);

    return (
        <>
            <AddServiceModal
                show={showAddServiceModal}
                setShow={setShowAddServiceModal}
                teamId={vObject?.object?.teamId || null}
            />

            <OffExpendTeamInfo
                show={showExpendTeamInfo}
                setShow={setShowExpendInfo}
            />

            <div>
                <ProposalShortageBlock kind="services" />

                {showSpinnerExpendTeam && <SpinnerBlock onlyBlur={true} show={true} />}
                <div className="crm-table-wrap">
                    <Table className="ExpandTeamTable table-hover table">
                        <thead>
                            <tr className="bg-light">
                                <td className="head-user">{t('fieldsService.user')}</td>
                                <td className="head-service">{t('fieldsService.service')}</td>
                                <td className="head-date">{t('fieldsService.date')}</td>
                                <td className="head-price">{t('productFields.price')}</td>
                                <td className="head-count">{t('productFields.count')}</td>
                                <td className="head-amount">{t('productFields.amount')}</td>
                                <td className="head-actions">{t('fieldsService.actions')}</td>
                            </tr>
                        </thead>
                        <ExpendTeamTableBody
                            setShowExpendInfo={setShowExpendInfo}
                            setShowSpinnerExpendTeam={setShowSpinnerExpendTeam}
                        />
                    </Table>
                </div>
            </div>

            {!isEditLocked && (
                <div className="text-center w-100 mt-4">
                    <Button
                        className="py-2"
                        size="sm"
                        onClick={() => setShowAddServiceModal(true)}
                    >
                        <SvgUsers className="me-2" />
                        {t('addService.btnAddService')}
                    </Button>
                </div>
            )}
        </>
    );
};

export default ObjectTabServices;
